import * as stylex from '@stylexjs/stylex';
import _ from 'lodash';
import { Field, useForm } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { FormFieldWrapper } from '@/formbuilder/FormFieldWrapper';
import { getValidationFunction } from '@/formbuilder/formbuilder.utilities';
import { faQuestionCircle } from '@seeqdev/icons/fa-sharp-regular-svg-icons';
import { Icon } from '@seeqdev/qomponents';
import { colors } from '@seeqdev/qomponents/colors.stylex';
import type { ValidatingFormComponent } from '@/formbuilder/formBuilder.types';

export interface PatternIF extends ValidatingFormComponent<string> {
  component: 'PatternFormComponent';
  min: number;
  max: number;
  label?: string;
}

export const PatternFormComponent = (props: PatternIF) => {
  const {
    name,
    testId = 'pattern',
    label,
    tooltip,
    min,
    max,
    validation,
    extendValidation,
    extraClassNames,
    customErrorText,
  } = props;

  const defaultValidation = (_value: string | undefined) => {
    return min === max;
  };

  const appliedValidation = getValidationFunction(defaultValidation, extendValidation, validation);

  const { t } = useTranslation();
  const formState = useForm().getState();
  const showError = _.has(formState.errors, name) && formState.hasValidationErrors;
  const labelText = label ? t(label) : undefined;
  const tooltipText = tooltip ? t(tooltip) : undefined;

  return (
    <FormFieldWrapper
      fieldXstyle={[props.xstyle, props.fieldXstyle]}
      wrapperXstyle={props.wrapperXstyle}
      labelXstyle={props.labelXstyle}
      testId={testId}
      extraClassNames={extraClassNames}
      showError={showError}
      customErrorText={customErrorText}>
      <Field<string> name={name} validate={appliedValidation}>
        {() => {
          return (
            <div {...stylex.props(styles.pattern)}>
              <div>{labelText}</div>
              {tooltip && <Icon icon={faQuestionCircle} large={true} tooltip={tooltipText} xstyle={styles.helpIcon} />}
            </div>
          );
        }}
      </Field>
    </FormFieldWrapper>
  );
};

const styles = stylex.create({
  pattern: { display: 'flex', flexDirection: 'row' },
  helpIcon: {
    paddingLeft: '.3125rem',
    color: {
      'default': colors.legacyToolsLink,
      ':hover': colors.legacyToolsPrimary,
      ':focus': colors.legacyToolsPrimary,
      ':active': colors.legacyToolsPrimary,
    },
  },
});
